import {RouterPrefix} from '@wix/wixstores-client-core/dist/es/src/constants';
import {LocaleKeys} from '../../../__generated__/LocaleKeys';
import {FedopsInteractions} from '../../constants';
import {getCategoryPageStatusForSite} from './categoriesRolloutManagerUtils';

export async function getCategoryPageSiteStatus(options) {
  const isCategorySiteRes = await getCategoryPageStatusForSite(
    options.initialAppData.metaSiteId,
    options.essentials.httpClient
  );
  return isCategorySiteRes.data.result.value;
}

export function shouldInstallCategoryPage(currentSiteCategoryPageState: boolean | null): boolean {
  const siteHadCategoryPageBefore = currentSiteCategoryPageState === true;
  const shouldInstallCategoryPageForTheFirstTime = currentSiteCategoryPageState === null;

  return siteHadCategoryPageBefore || shouldInstallCategoryPageForTheFirstTime;
}

export async function createCategoryPageRouter(ecomPublicApi, categoryPageRef, fedopsLogger) {
  fedopsLogger?.interactionStarted?.(FedopsInteractions.CategoryAddRouter, {customParams: {categoryPageRef}});
  const routerRef = await ecomPublicApi.addRouter(RouterPrefix.CATEGORY);
  fedopsLogger?.interactionEnded?.(FedopsInteractions.CategoryAddRouter);

  fedopsLogger?.interactionStarted?.(FedopsInteractions.CategoryConnectRouter, {
    customParams: {categoryPageRef, routerRef},
  });

  const router = await ecomPublicApi.getRouter(routerRef);
  await ecomPublicApi.connectPageToRouter({
    pageRef: categoryPageRef,
    routerRef,
    pageRoles: [RouterPrefix.CATEGORY],
  });
  fedopsLogger?.interactionEnded?.(FedopsInteractions.CategoryConnectRouter);

  return router;
}

export function addAllProductsCategoryToDefaultSiteMenu(editorSdk, t, router, categoryPageRef, isHarmony) {
  const menuItem = {
    menuId: 'CUSTOM_MAIN_MENU',
    menuItem: {
      type: isHarmony ? 'Builder.MenuItem' : 'BasicMenuItem',
      isVisible: true,
      label: t(LocaleKeys().siteMenu.store.defaultPage.name),
      link: {
        type: 'DynamicPageLink',
        routerId: router.id,
        pageId: isHarmony ? undefined : categoryPageRef.id,
        innerRoute: 'all-products',
      },
    },
  };

  return editorSdk.menu.addItem('', menuItem);
}
